import { Controller } from "@hotwired/stimulus";
import StimulusReflex from "stimulus_reflex";

export default class extends Controller {
  static targets = ["competitionSelect", "eventSelect", "prizeSelect"];

  connect() {
    console.log("CompetitionFormController connected");
    StimulusReflex.register(this);
  }

  handleCompetitionChange(event) {
    const competitionId = event.target.value;
    console.log("Competition changed to:", competitionId);

    if (!competitionId) {
      this.clearEventSelect();
      this.clearPrizeSelect();
      return;
    }

    // Trigger reflexes to load events and prizes
    this.loadEvents(competitionId);
    this.loadPrizes(competitionId);
  }

  loadEvents(competitionId) {
    console.log("Loading events for competition:", competitionId);
    // Clear the event select first
    this.clearEventSelect();

    // Set the dataset for the reflex
    this.element.dataset.competition_id = competitionId;

    // Trigger the reflex to load events
    this.stimulate("CompetitionEventSearch#search").then(() => {
      // Re-enable the select after morphing
      if (this.hasEventSelectTarget) {
        this.eventSelectTarget.disabled = false;
      }
    });
  }

  loadPrizes(competitionId) {
    console.log("Loading prizes for competition:", competitionId);
    // Clear the prize select first
    this.clearPrizeSelect();

    // Set the dataset for the reflex
    this.element.dataset.competition_id = competitionId;

    // Trigger the reflex to load prizes
    this.stimulate("CompetitionPrizeSearch#search").then(() => {
      // Re-enable the select after morphing
      if (this.hasPrizeSelectTarget) {
        this.prizeSelectTarget.disabled = false;
      }
    });
  }

  clearEventSelect() {
    if (this.hasEventSelectTarget) {
      this.eventSelectTarget.innerHTML =
        '<option value="">Select an event</option>';
      this.eventSelectTarget.disabled = true;
      this.eventSelectTarget.value = "";
    }
  }

  clearPrizeSelect() {
    if (this.hasPrizeSelectTarget) {
      this.prizeSelectTarget.innerHTML =
        '<option value="">Select a prize</option>';
      this.prizeSelectTarget.disabled = true;
      this.prizeSelectTarget.value = "";
    }
  }
}
